// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_IMJ","left":"styles_left__8hTc3"};